import React, { useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { signupFailedAction } from "../../store/actions/AuthActions";
import Swal from "sweetalert2";
import axios from "axios";
import BaseUrl from "../../BaseUrl";
import swal from "sweetalert";
var bnr = require("./../../images/background/bg6.jpg");

function Register2(props) {
  const [email, setEmail] = useState("");
  const [, setGetemail] = useState("");
  const [, setGetid] = useState("");
  const [, setGetuserid] = useState("");
  const [loader, setLoader] = useState(false);
  let errorsObj = {
    email: "",
    password: "",
    password_confirmation: "",
    role: "",
    phone_number: "",
    address: "",
    user_date: "",
    business_type: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [password, setPassword] = useState("");
  const [password_confirmation, setpassword_confirmation] = useState("");
  const [address, setAddress] = useState("");
  const [phone_number, setPhonenumber] = useState("");
  const [business_type, setBusiness] = useState("");
  const [user_date, setDate] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();
  const slug = useParams();

  function onSignUp() {
    setLoader(true);

    let error = false;
    const errorObj = { ...errorsObj };
    if (email === "") {
      errorObj.email = "Email is Required";
      setLoader(false);
      error = true;
    }
    if (password === "") {
      errorObj.password = "Password is Required";
      error = true;
      setLoader(false);
    }
    if (password_confirmation !== password) {
      errorObj.password_confirmation =
        "The password confirmation does not match.";
      error = true;
      setLoader(false);
    }
    if (address === "") {
      errorObj.address = "Required";
      error = true;
      setLoader(false);
    }
    if (phone_number === "") {
      errorObj.phone_number = "Required";
      error = true;
      setLoader(false);
    } else {
      var mobPattern = /^\d{10}$/;
      if (!mobPattern.test(phone_number)) {
        error = true;
        setLoader(false);

        errorObj.phone_number = "Invalid phone number. Must be 10 Characters";
      }
    }
    if (business_type === "") {
      errorObj.business_type = "Please Enter Your Business";
      error = true;
      setLoader(false);
    }
    if (user_date === "") {
      errorObj.date = "Please Enter Your date";
      error = true;
      setLoader(false);
    }
    setErrors(errorObj);
    if (error) return;

    //axios call
    const postData = {
      email,
      password,
      password_confirmation,
      phone_number,
      user_date,
      address,
      business_type,
      returnSecureToken: true,
    };
    axios
      .post(
        `https://businesssistepanel.developer-hi.xyz/api/register`,
        postData
      )
      .then((response) => {
        console.log(response);
        setLoader(false);
        Select_Plan(response?.data?.user?.id);
        setGetuserid(response?.data?.user?.id);
        setGetemail(response?.data?.user?.email);
      })
      .catch((errors) => {
        setLoader(false);

        console.log(errors?.response?.data?.errors[0]);
        const errorMessage = errors?.response?.data?.errors[0];
        swal({
          icon: "error",
          title: errorMessage,
        });
        console.log(errorMessage);
        dispatch(signupFailedAction(errorMessage));
      });
  }
  const Select_Plan = (id) => {
    // setLoader(true);
    var config = {
      method: "get",
      url: `${BaseUrl.baseurl}/plans/${slug.slug}/${id}`,
    };

    axios(config)
      .then(function (response) {
        // setLoader(false);
        console.log(response?.data);
        if (response?.data?.status === true) {
          setGetid(response?.data?.plan?.id);
          history.push(`/Checkout/${response?.data?.plan?.id}/${email}/${id}`);
        } else {
          console.log(response);
        }
      })
      .catch(function (error) {
        console.log(error);

        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: "asdfasdsad",
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };

  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <div className="page-wraper">
        <div className="browse-job login-style3">
          <div
            className="bg-img-fix"
            style={{ backgroundImage: `url(${bnr})`, height: "100vh" }}
          >
            <div className="row">
              <div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 bg-white z-index2 relative p-a0 content-scroll skew-section left-bottom">
                <div className="login-form style-2">
                  <div className="logo-header text-center p-tb30">
                    <Link to={"./"}>
                      <img src={require("./../../images/Site1.png")} alt="" />
                    </Link>
                  </div>
                  <div className="clearfix"></div>
                  <div className="dez-separator-outer ">
                    <div className="dez-separator bg-primary style-liner"></div>
                  </div>
                  <div className="tab-content nav tab">
                    <div id="login" className="">
                      {/* {props.errorMessage && (
                      <div className="">{props.errorMessage}</div>
                    )}
                    {props.successMessage && (
                      <div className="">{props.successMessage}</div>
                    )} */}
                      <div className=" dez-form ">
                        <div className="row">
                          <div className="col-md-6">
                            <h3 className="form-title ">Register</h3>
                          </div>
                          <div className="col-md-6">
                            <div className="text-center bottom">
                              <Link
                                to={"/login"}
                                className="site-button right-arrow button-sm float-right"
                              >
                                Login
                              </Link>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <input
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            type="email"
                            className="form-control"
                            placeholder="hello@example.com"
                          />
                          <div className="text-danger">
                            {errors.email && <div>{errors.email}</div>}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <input
                                value={password}
                                type="password"
                                className="form-control"
                                placeholder="Enter Password"
                                defaultValue="Password"
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              <div className="text-danger">
                                {errors.password && (
                                  <div>{errors.password}</div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <input
                                value={password_confirmation}
                                type="password"
                                className="form-control"
                                placeholder="Enter Password"
                                defaultValue="password_confirmation"
                                onChange={(e) =>
                                  setpassword_confirmation(e.target.value)
                                }
                              />
                              <div className="text-danger">
                                {errors.password_confirmation && (
                                  <div>{errors.password_confirmation}</div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Phone Number"
                                defaultValue="phonenumber"
                                onChange={(e) => setPhonenumber(e.target.value)}
                              />
                              <div className="text-danger">
                                {errors.phone_number && (
                                  <div>{errors.phone_number}</div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <input
                                type="date"
                                className="form-control"
                                placeholder="Date"
                                onChange={(e) => setDate(e.target.value)}
                              />
                              <div className="text-danger">
                                {errors.date && <div>{errors.date}</div>}
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-md-6">
                            <div className="form-group">
                              <select
                                className="form-control"
                                placeholder="Professional"
                                onChange={(e) => setRole(e.target.value)}
                              >
                                <option selected disabled>
                                  Select Your Professinaol
                                </option>
                                <option>User</option>
                                <option>Business</option>
                              </select>
                              <div className="text-danger">
                                {errors.role && <div>{errors.role}</div>}
                              </div>
                            </div>
                          </div> */}
                          <div className="col-md-12">
                            <div className="form-group">
                              <input
                                value={address}
                                type="text"
                                className="form-control"
                                placeholder="Address"
                                onChange={(e) => setAddress(e.target.value)}
                              />
                              <div className="text-danger">
                                {errors.address && <div>{errors.address}</div>}
                              </div>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Name Of Business"
                                onChange={(e) => setBusiness(e.target.value)}
                              />
                              <div className="text-danger">
                                {errors.business_type && (
                                  <div>{errors.business_type}</div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="form-group">
                          <button
                            type="submit"
                            onClick={onSignUp}
                            className="site-button btn-block dz-xs-flex m-r5"
                          >
                            Sign up
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bottom-footer clearfix row text-center">
                    <div className="col-lg-12 text-center">
                      <span>
                        {" "}
                        © Copyright by
                        <a href="https:www.hnhtechsolutions.com/">
                          HnH Tech Solutions{" "}
                        </a>{" "}
                        All rights reserved.
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    errorMessage: state.auth.errorMessage,
    successMessage: state.auth.successMessage,
    showLoading: state.auth.showLoading,
  };
};
export default connect(mapStateToProps)(Register2);
